var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" "+_vm._s(_vm.value)+"% "),_c('i',{staticClass:"fa fa-signal ml-1",class:_vm.className})])}
var staticRenderFns = []

export { render, staticRenderFns }